export default "__VITE_ASSET__C2sT2PDS__"